import { createContext, useContext, useEffect, useState } from "react";
import { AuthStrapiContext } from "./AuthStrapiV3Context";
import { ActualLangContext } from "./ActualLangContext";
import axios from "axios";

/**
 * Factory para crear contextos de contenido con patrón similar
 * Reduce duplicación en contextos que solo cargan SEOContent desde diferentes endpoints
 * 
 * @param {string} endpoint - El endpoint de la API (sin la URL base ni locale)
 * @param {string} contextName - Nombre del contexto para mensajes de error
 * @returns {{ Context: React.Context, Provider: React.FC }}
 */
export const createContentContext = (endpoint, contextName) => {
  const Context = createContext({});

  const Provider = ({ children }) => {
    const { actualLang } = useContext(ActualLangContext);
    const { token } = useContext(AuthStrapiContext);

    const [loadedData, setLoadedData] = useState(false);
    const [SEOContent, setSEOContent] = useState({});

    useEffect(() => {
      setLoadedData(false);
      const url = `${process.env.REACT_APP_URL_API}/${endpoint}?_locale=${actualLang}`;
      if (token) {
        axios
          .get(url, { headers: { Authorization: `Bearer ${token}` } })
          .then((res) => {
            setSEOContent(res.data?.SEOMetaData);
            setLoadedData(true);
          })
          .catch((err) =>
            console.log(
              `Ocurrió un error al obtener los datos de la página de ${contextName}: ${err.message}`
            )
          );
      }
    }, [actualLang, token]);

    return (
      <Context.Provider value={{ loadedData, SEOContent }}>
        {children}
      </Context.Provider>
    );
  };

  return { Context, Provider };
};

export default createContentContext;

